/**
 * Created by daniel.gonzalez on 3/24/15.
 */

'use strict';

var $ = require('dibs-jquery-shim');
var SV = require('server-vars');
var uriHelper = require('bunsen/helpers/uri.es');
var referrerHelpers = require('../../global/tracking/referrerHelpers');
var mobileCheck = require('bunsen/helpers/mobileCheck');
var url = uriHelper.URL;

var DEEP_LINK_BASE = 'dibs://www.1stdibs.com';
var DEEP_LINK_BASE_MC = 'dibsmc://www.1stdibs.com';

/**
 * @param {string} key - query param in the current page's url
 * @returns {boolean} - true if the app supports the query param
 */
function querySupported(key) {
    var queries = SV.get('deepLinks.queries') || {};
    var keyLowerCased = key.toLowerCase();
    return typeof queries[keyLowerCased] !== 'undefined';
}

function wasLoginRedirected() {
    return url.queryKey && url.queryKey.ep && /login/.test(url.queryKey.modal);
}

function getDeepLinkBase(path) {
    return /^\/my\/conversations/.test(path) ? DEEP_LINK_BASE_MC : DEEP_LINK_BASE;
}

/**
 * @param path {string} - the path for the current page
 * @param queryParams {string} - all the query params for the current page
 * @returns {string} - returns the path concatenated with the query params supported in the app
 */
function createDeepLinkPath(path, queryParams) {
    var params = queryParams.split('&');
    var supportedParams = [];
    var length = params.length;
    var key;
    var i;

    for (i = 0; i < length; i++) {
        key = params[i].split('=')[0];
        if (querySupported(key)) {
            supportedParams.push(params[i]);
        }
    }

    return path + '?' + supportedParams.join('&');
}

module.exports = {
    /**
     *
     * @returns {boolean} - true if the page is supported in the app
     */
    pageSupported: function(path) {
        var supported = false;
        var regexs = SV.get('deepLinks.regexs') || [];
        var length = regexs.length;
        var value;
        var regex;
        var i;

        path = path || url.path;

        for (i = 0; i < length; i++) {
            value = regexs[i];
            regex = new RegExp(value, 'i');
            if (regex.test(path)) {
                supported = true;
                break;
            }
        }

        if (path === '/') {
            // home page
            supported = true;
        }

        return supported;
    },

    createDeepLink: function(updatedUrl) {
        var path = updatedUrl && updatedUrl.path ? updatedUrl.path : url.path;
        var query = updatedUrl && updatedUrl.query ? updatedUrl.query : url.query;
        return getDeepLinkBase(path) + createDeepLinkPath(path, query);
    },

    /**
     * If the user is redirected and does not have the app, a safari modal pops up saying the page cannot be opened.
     * The safari modal will not pop up if the user is redirected in an iframe.
     * http://stackoverflow.com/questions/19701708/how-to-prevent-ios-safari-alert-when-trying-to-open-non-installed-native-app
     */
    openApp: function(deepLink) {
        $('<iframe />')
            .attr('src', deepLink)
            .attr('style', 'display:none;')
            .appendTo('body');
    },

    /**
     * If dibs-app param is true or false, overwrites the regular logic for redirecting to the app.
     * true -> redirects to the app.
     * false -> does not redirect to the app.
     * @returns {boolean} - true if the method should override the regular logic for redirecting to the app
     */
    forcedRedirect: function(updatedUrl) {
        var appParam;
        var deepLink;
        updatedUrl = updatedUrl || url;
        appParam = updatedUrl.queryKey['dibs-app'];

        if (appParam === 'true') {
            deepLink = this.createDeepLink();
            this.openApp(deepLink);
        }

        return appParam === 'true' || appParam === 'false';
    },

    forwardFromEmail: function() {
        var updatedUrl = url;
        var deepLink;

        if (wasLoginRedirected()) {
            updatedUrl = uriHelper.parseUri(
                url.protocol + '://' + url.host + decodeURIComponent(url.queryKey.ep)
            );
        }

        if (
            !this.forcedRedirect(updatedUrl) &&
            mobileCheck.iPhone() &&
            referrerHelpers.isEmailReferrer(updatedUrl.queryKey) &&
            this.pageSupported(updatedUrl.path)
        ) {
            deepLink = this.createDeepLink(updatedUrl);
            this.openApp(deepLink);
        }
    },
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/core/deepLink.js
// module id = 4165
// module chunks = 63